import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import PointContext from "../../../context/point/context";
import { IPoint } from "../../../models/point/response";
import {
  getPointStatus,
  getPointStatusColor,
} from "../../../models/point/enum";
import Tag from "../../general/antd/tag";

interface IProps {}

const PointTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(PointContext);

  const columns: ColumnProps<IPoint>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("name"),
      dataIndex: "name",
      align: "center",
      key: "name",
      sorter: {
        multiple: 2,
      },
    },
    {
      title: t("employ"),
      dataIndex: "employ",
      align: "center",
      key: "employ",
      render: (_, record) => {
        return (
          <>
            {record?.employ?.user?.firstName +
              " " +
              record?.employ?.user?.lastName}
          </>
        );
      },
    },
    {
      title: t("status"),
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getPointStatus(record?.status)}
            color={getPointStatusColor(record?.status)}
          />
        );
      },
    },
    {
      title: t("city"),
      dataIndex: "city",
      align: "center",
      key: "city",
      render: (_, record) => {
        return <Tag title={record?.city?.name} />;
      },
    },
    {
      title: t("area"),
      dataIndex: "area",
      align: "center",
      key: "area",
      render: (_, record) => {
        return <Tag title={record?.area?.name} />;
      },
    },
    {
      title: t("employ"),
      dataIndex: "employ",
      align: "center",
      key: "employ",
      render: (_, record) => {
        return <Tag title={record?.employ?.user?.cleanMobile} />;
      },
    },
    {
      title: t("debt_value"),
      dataIndex: "debtValue",
      align: "center",
      key: "debtValue",
      sorter: {
        multiple: 3,
      },
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
              onClick={(e) => {
                const url = `/points/details/${record?.id}`;
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
            <EditBtn
              onClick={(e) => {
                const url = `/points/update/${record?.id}`; 
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deletePoint(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default PointTable;
